import { CalendarCheckIcon } from './CalendarCheckIcon';

/**
 * author: Google
 * id 62008F88-6B17-4277-9155-B596476629A1
 * name calendar-check
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-check.svg
 * tags
 * - Date / Time 
 */
export const CalendarTaskIcon = CalendarCheckIcon;
export default CalendarTaskIcon